import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import OpeningHours from "../opening-hours/OpeningHours";
import LiveChatButton from "../../../live-chat-button/LiveChatButton";
import styles from "./contact-chat.module.scss";

function ContactChat({
  className,
  config: { channel, open, displayTimes, percentage },
  location,
  displayOpeningHours,
  displayDescriptionParagraph,
  displayHeading = true,
}) {
  const getIfEnabled = () => Math.random() < percentage / 100;

  const unavailableChatOption = (
    <div>
      <br />
      <p>
        <b>Currently unavailable</b>
      </p>
      <p>You can still get in touch by calling our Customer Service team.</p>
      {channel === "TechnicalSupport" && <OpeningHours openingHours={displayTimes} />}
    </div>
  );

  const outOfHoursOption = (
    <div>
      <p>Our team is not available for live chat at this time.</p>
      <br />

      {channel === "TechnicalSupport" && (
        <>
          <p>
            <b>Opening times</b>
          </p>
          <OpeningHours openingHours={displayTimes} />
        </>
      )}
    </div>
  );

  const openChatOption = () => (
    <div>
      {displayDescriptionParagraph && (
        <p>Contact our team via our website. You can save the chat transcript for reference.</p>
      )}
      <div className={styles["contact-chat__button"]}>
        <LiveChatButton channel={channel} buttonLocation={location} />
      </div>
      {displayOpeningHours && <OpeningHours openingHours={displayTimes} />}
    </div>
  );

  const getChatDOM = () => {
    if (!getIfEnabled()) {
      return unavailableChatOption;
    }
    if (!open) {
      return outOfHoursOption;
    }
    return openChatOption();
  };

  return (
    <div className={classnames(className, styles["contact-chat"])} data-test="container-chat">
      {displayHeading && <h4 className={styles["contact-chat__title"]}>Live chat</h4>}
      {getChatDOM()}
    </div>
  );
}

ContactChat.propTypes = {
  config: PropTypes.shape({
    channel: PropTypes.string,
    open: PropTypes.bool,
    closedMessage: PropTypes.string,
    displayTimes: PropTypes.arrayOf(
      PropTypes.shape({
        order: PropTypes.number,
        days: PropTypes.string,
        times: PropTypes.string,
      }),
    ),
    openingTimes: PropTypes.arrayOf(
      PropTypes.shape({
        jsIndex: PropTypes.number,
        open: PropTypes.string,
        close: PropTypes.string,
      }),
    ),
    percentage: PropTypes.number,
  }).isRequired,
  className: PropTypes.string,
  location: PropTypes.string,
  displayOpeningHours: PropTypes.bool,
  displayDescriptionParagraph: PropTypes.bool,
};

ContactChat.defaultProps = {
  className: undefined,
  location: undefined,
  /** Should opening hours be rendered */
  displayOpeningHours: true,
  /** Should the description paragrah be rendered */
  displayDescriptionParagraph: true,
};

export default ContactChat;
